import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Icon from './AppIcon';

const ThemeToggle = ({ compact = false }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`
        relative flex items-center justify-center
        ${compact 
          ? 'w-9 h-9 sm:w-10 sm:h-10' :'w-10 h-10 sm:w-11 sm:h-11'
        }
        rounded-lg transition-all duration-300 ease-out
        hover:scale-105 active:scale-95
        ${isDark 
          ? 'bg-slate-700 hover:bg-slate-600 text-amber-300' :'bg-slate-100 hover:bg-slate-200 text-slate-700'
        }
        border border-border shadow-sm hover:shadow-md
        touch-manipulation
        group
      `}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {/* Light Mode Icon (Sun) */}
      <div
        className={`
          absolute transition-all duration-300 ease-out
          ${isDark 
            ? 'opacity-0 scale-0 rotate-90' :'opacity-100 scale-100 rotate-0'
          }
        `}
      >
        <Icon 
          name="Sun" 
          size={compact ? 18 : 20} 
          className="text-amber-500 group-hover:text-amber-600 transition-colors"
        />
      </div>

      {/* Dark Mode Icon (Moon) */}
      <div
        className={`
          absolute transition-all duration-300 ease-out
          ${isDark 
            ? 'opacity-100 scale-100 rotate-0' :'opacity-0 scale-0 -rotate-90'
          }
        `}
      >
        <Icon 
          name="Moon" 
          size={compact ? 18 : 20} 
          className="text-amber-300 group-hover:text-amber-200 transition-colors"
        />
      </div>

      {/* Subtle indicator dot */}
      <div 
        className={`
          absolute -bottom-0.5 -right-0.5 
          w-2 h-2 rounded-full 
          transition-colors duration-300
          ${isDark ? 'bg-amber-300' : 'bg-amber-500'}
        `}
      />
    </button>
  );
};

export default ThemeToggle;